import CheckRankInput from "components/check-rank-input";
import Reward from "components/event-item/reward";
import dayjs from "dayjs";
import { EventEntity, EventGroupEntity } from "interfaces";
import { useEffect, useState } from "react";
import { Modal } from "semantic-ui-react";
import { api } from "services";
import Rank from "./rank";

export default function ChampionShip() {
  const [group, setGroup] = useState<EventGroupEntity>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [activeEvent, setActiveEvent] = useState<EventEntity>(null);
  const [openRule, setOpenRule] = useState<boolean>(false);
  const [search, setSearch] = useState<string>("");
  const [showEventReward, setShowEventReward] = useState<EventEntity>(null);
  const [showRank, setShowRank] = useState<boolean>(false);
  const [showFirst, setShowFirst] = useState<boolean>(true);

  useEffect(() => {
    async function load() {
      try {
        setLoading(true);
        let rs = await api.post("/event-group/get-all-event-groups", {
          status: "championship",
          is_event_page: false
        });
        setGroup(rs[0]);
        setActiveEvent(rs[0].eventInfos[0]);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  function renderPrizeButton() {
    return (
      <img
        alt="prize"
        src={require("./prize.png")}
        className="h-16 mt-4 cursor-pointer mx-auto"
        onClick={() => {
          setShowEventReward(activeEvent);
        }}
      />
    );
  }
  return (
    <div className="w-full">
      <Modal
        open={showFirst}
        onClose={() => {
          setShowFirst(false);
        }}
        closeIcon={
          <div className="text-red cursor-pointer absolute float-right -right-2 -top-2"
            onClick={() => {
              setShowFirst(false);
            }}
          >
            <img src="/assets/images/icons/close-icon.svg" alt="close" className="" />
          </div>
        }
      >
        <div className="bg-transparent">
          <img src={require('./bg-popup.png')} alt="popup" />
        </div>
      </Modal>

      <Modal
        open={showEventReward !== null}
        onClose={() => {
          setShowEventReward(null);
        }}
        closeIcon
      >
        <div className="bg-transparent">
          <div className="bg-[#1c2023] relative rounded-md ">
            <p className="text-center text-2xl text-white font-cookie font-semibold p-6">
              Rewards list
            </p>
            <img
              src={require(".//modal-separate.png")}
              className="mx-auto"
              alt="separate"
            />
            <Reward
              groupInfo={group}
              showRank={showRank}
              setShowRank={setShowRank}
              rankEvent={showEventReward}
              eventId={activeEvent?.id}
            />
          </div>
        </div>
      </Modal>
      <Modal
        basic
        open={openRule}
        onClose={() => {
          setOpenRule(false);
        }}
      >
        <div className="bg-transparent">
          <div className="bg-[#0F1011] relative rounded-lg ">
            <img
              alt="rule"
              onClick={() => {
                setOpenRule(false);
              }}
              src={require("./btn-close-modal.png")}
              className="absolute -top-3 -right-3 cursor-pointer"
            />
            <p className="text-center text-2xl text-white font-cookie font-semibold p-6">
              Rule
            </p>
            <img
              alt="seperate"
              src={require("./modal-separate.png")}
              className="mx-auto"
            />
            <div className="text-white py-4 px-6 leading-8">
              🏆 Only in Soft Launch: Join free to play Monsterra on OKC NOW!<br />
              ✔️ Follow Twitter: https://twitter.com/Monsterra_P2E<br />
              ✔️ RT (Softlaunch Announcement)<br />
              ✔️ Signup with OKX option at https://play.monsterra.io/?src=okc<br />
              ✔️ Play Monsterra and invite friends at: https://dao.monsterra.io/#/referral<br />
              <br />
              🎁Rewards:<br />
              - Top 300 random login wallets: $10 in MSTR /winner<br />
              - Top 5 highest level: $50 - $40 - $30 - $20 - $10 in USDT in a row<br />
              - Top 5 most referrals: $100 / winner in OKT<br />
              <br />
              📌Notes:<br />
              - Only applies to newly registered USER IDs after Jan 10, 2023 on OKC (other networks will not be counted). <br />
              - Referrees of top referral  will need to spend at least 1 MSTR.<br />
            </div>
            <div className="bg-[#292929] mt-4 p-4 rounded-b-lg">
              <img
                alt="close"
                src={require("./btn-close.png")}
                className="h-12 mx-auto cursor-pointer"
                onClick={() => {
                  setOpenRule(false);
                }}
              />
            </div>
          </div>
        </div>
      </Modal>
      <div className="fixed top-0 left-0 w-full h-full z-0">
        <img alt="bg" src={require("./bg.png")} className="w-full h-full object-cover" />
      </div>
      <div className="w-full z-10 relative">
        <div className="w-full flex justify-center">
          <img
            alt="ava"
            src={require("./ava.png")}
            className="max-w-[500px] w-full mt-10 md:mt-24"
          />
        </div>
        <div className="w-full flex justify-center">
          <div
            style={{ backgroundImage: `url(${require("./time.png")})` }}
            className="bg-cover p-2 mt-6"
          >
            {group && (
              <div className="text-white font-semibold text-center flex flex-col lg:flex-row gap-2">
                <p>
                  Start time: {!group.start_time && "--:-- UTC ---- --"}
                  {group.start_time &&
                    dayjs(group.start_time).toDate().toUTCString().split(",")[1]}
                </p>
                -
                <p>
                  End time: {/* @ts-ignore */}
                  {!group.end_time && "--:-- UTC ---- --"}
                  {group.end_time &&
                    dayjs(group.end_time).toDate().toUTCString().split(",")[1]}
                </p>
              </div>
            )}
          </div>
        </div>
        <div className="flex justify-between mt-6">
          <img
            alt="rule"
            src={require("./rule-btn.png")}
            className="h-10  cursor-pointer order-1  lg:hidden"
            onClick={() => {
              setOpenRule(true);
            }}
          />
          <a href="https://play.monsterra.io" className="order-2 lg:hidden">
            <img alt="play" src={require("./play-btn.png")} className="h-10" />
          </a>
        </div>
        <div className="max-w-[700px] mx-auto">
          <div className="flex justify-between mt-6 gap-10">
            <img
              alt="rule"
              src={require("./rule-btn.png")}
              className="h-10 cursor-pointer hidden lg:block"
              onClick={() => {
                setOpenRule(true);
              }}
            />
            <CheckRankInput
              onSearch={(val: string) => {
                console.log("set search ", val);
                setSearch(val);
              }}
            />
          </div>
          <div className="w-full max-w-[700px] mx-auto mt-6">
            {group && (
              <div className="flex justify-between text-white text-xl font-semibold flex-col lg:flex-row gap-4">
                {group.eventInfos.map((e: EventEntity, idx: number) => (
                  <div
                    key={idx}
                    className="w-full cursor-pointer"
                    onClick={() => {
                      setActiveEvent(e);
                    }}
                  >
                    <p
                      className={`${activeEvent?.id === e.id && "text-[#E89F01] text-outline-orange"
                        } text-center`}
                    >
                      {e.name}
                    </p>
                    {activeEvent?.id === e.id && (
                      <img
                        alt="underline"
                        src={require("./underline.png")}
                        className="w-full mt-2 h-[2px]"
                      />
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
          {renderPrizeButton()}
          <Rank eventId={activeEvent?.id} search={search} eventInfo={activeEvent} />
        </div>
      </div>
    </div>
  );
}
